<template>
  <div style="padding: 15px;background: #fff;">
    <!-- 工具栏 -->
    <div class="table-page-search-wrapper" style="margin-bottom:10px;">
      <a-form layout="inline">
        <a-form-item :wrapper-col="{ span: 30 }">
          <a-input
            placeholder="用户名称查找"
            @change="changeSearchText"
            style="width:150px"
          />
        </a-form-item>
        <a-form-item>
          <a-select
            placeholder="请选择企业"
            @change="changeEnterpriseSearch"
            style="width:180px"
          >
            <a-select-option value="">
              全部企业
            </a-select-option>
            <a-select-option
              v-for="item in enterpriseList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            style="margin-left: 10px;"
            @click="searchList"
          >
            <a-icon type="search" />
            查询
          </a-button>
          &emsp;
        </a-form-item>
        <a-button
          type="primary"
          style="float:right;margin-top:4px;"
          @click="showEnterpriseModal('add')"
        >
          <a-icon type="plus" />
          添加用户
        </a-button>
      </a-form>
    </div>

    <!-- 表格 -->
    <a-table
      :columns="columns"
      :dataSource="tableData"
      :pagination="pagination"
      :loading="tableLoading"
    >
      <span slot="action" slot-scope="item">
        <a href="javascript:;" @click="showEnterpriseModal('edit', item)">
          修改
        </a>
        <a-divider type="vertical" />
        <a href="javascript:;" @click="setRoleShow(item)">设置角色</a>
      </span>
    </a-table>

    <!-- 模态框 -->
    <!-- 添加修改用户 -->
    <add-user-modal
      :show-modal="userModalShowFlag"
      @cancel="handleUserModalCancel"
      @submit="handleUserModalSubmit"
      :confirmLoading="userModalConfirmLoading"
      :addInfo="userModelInfo"
      :submitType="userSubmitType"
    ></add-user-modal>
    <!-- 设置角色 -->
    <set-role-modal
      :show-modal="roleModalShowFlag"
      @cancel="handleRoleModalCancel"
      @submit="handleRoleModalSubmit"
      :userId="currentUserId"
    >
    </set-role-modal>
  </div>
</template>
<script>
import { getUserList, addUser, editUser } from '@/apis/user'
import { getEnterpriseDropdownList } from '@/apis/enterprise'
import addUserModal from './tpl/add-edit-user'
import setRoleModal from './tpl/set-role'

const columns = [{
  title: '用户名',
  dataIndex: 'userName',
  key: 'userName'
}, {
  title: '所在企业',
  key: 'enterprise',
  dataIndex: 'enterprise'
}, {
  title: '手机',
  dataIndex: 'userPhone',
  key: 'userPhone'
}, {
  title: '邮箱',
  key: 'email',
  dataIndex: 'email'
}, {
  title: '创建时间',
  key: 'createTime',
  dataIndex: 'createTime'
}, {
  title: '操作',
  key: 'action',
  scopedSlots: { customRender: 'action' }
}]

export default {
  data () {
    return {
      tableData: [],
      columns,
      tableLoading: false,
      pagination: {
        onChange: (page, pageSize) => {
          this.pagination.current = page
          this.pagination.pageSize = pageSize
          this._getUserList()
        },
        total: 0,
        pageSize: 12,
        current: 1,
        size: 'middle',
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['12', '24', '36', '48'],
        defaultPageSize: 12,
        showSizeChanger: true,
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this._getUserList()
        }
      },
      searchText: '',
      searchEnterpriseId: '',
      // 模态框
      userModalShowFlag: false,
      userModalConfirmLoading: false,
      userSubmitType: 'add',
      userModelInfo: {
        userName: '',
        password: '',
        userPhone: '',
        email: ''
      },
      enterpriseList: [],
      // 角色
      roleModalShowFlag: false,
      currentUserId: ''
    }
  },

  methods: {
    // 设置角色模态框
    handleRoleModalCancel () {
      this.roleModalShowFlag = false
    },
    handleRoleModalSubmit (data) {
      this.roleModalShowFlag = false
    },
    setRoleShow (item) {
      this.roleModalShowFlag = true
      this.currentUserId = item.id
    },
    // 添加 -编辑 -用户模态框
    handleUserModalCancel () {
      this.userModalShowFlag = false
    },
    handleUserModalSubmit (form) {
      form.validateFields(
        (err, values) => {
          if (!err) {
            this.userModalConfirmLoading = true

            let params = {
              UserName: values.userName,
              Password: values.password,
              CompanyId: values.enterpriseId,
              PhoneNumber: values.userPhone,
              Email: values.email
            }

            if (this.userSubmitType === 'add') {
              if (params.Id) delete params.id
              addUser(params).then(res => {
                if (res.data.state === 1) {
                  this.$message.success('添加成功')
                  this.userModalShowFlag = false
                  form.resetFields()
                }
                this.userModalConfirmLoading = false
                this.pagination.current = 1
                this._getUserList()
              })
            } else {
              params.Id = values.id
              editUser(params).then(res => {
                if (res.data.state === 1) {
                  this.$message.success('修改成功')
                  this.userModalShowFlag = false
                  form.resetFields()
                }

                this.userModalConfirmLoading = false
                this._getUserList()
              })
            }
          }
        }
      )
    },
    showEnterpriseModal (type, data) {
      if (type === 'add') {
        // 新增
        this.userModelInfo = {
          userName: '',
          password: '',
          userPhone: '',
          email: ''
        }
        this.userSubmitType = 'add'
      } else if (type === 'edit') {
        // 编辑
        this.userModelInfo = {
          userName: data.userName,
          password: '',
          enterpriseId: data.enterpriseId,
          userPhone: data.userPhone,
          email: data.email ? data.email : '',
          id: data.id
        }
        this.userSubmitType = 'edit'
      }

      this.userModalShowFlag = true
    },
    // 检索
    changeSearchText (e) {
      this.searchText = e.target.value
    },
    searchList () {
      this.pagination.current = 1
      this._getUserList()
    },
    changeEnterpriseSearch (value) {
      this.searchEnterpriseId = value
    },
    // 获取用户列表
    _getUserList () {
      this.tableLoading = true
      getUserList({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        search: this.searchText,
        companyId: this.searchEnterpriseId
      }).then(res => {
        const result = res.data.attribute

        this.pagination.total = result.count
        this.tableData = result.rows.map(item => ({
          key: item.id,
          id: item.id,
          enterpriseId: item.companyId,
          userName: item.userName,
          userPhone: item.phoneNumber,
          enterprise: item.companyName,
          email: item.email,
          createTime: item.createTime.split('T')[0] + ' ' + item.createTime.split('T')[1].split('.')[0]
        }))

        this.tableLoading = false
      })
    },
    // 获取企业下拉
    _getEnterpriseDropdownList () {
      getEnterpriseDropdownList().then(res => {
        this.enterpriseList = res.data.attribute
      })
    }
  },

  mounted () {
    this._getUserList()
    this._getEnterpriseDropdownList()
  },
  components: {
    addUserModal,
    setRoleModal
  }

}
</script>
<style lang="less" scoped>
</style>
